import _ from 'underscore';
import { useCallback, useState } from 'react';
import { usePromisify } from '@bingads-webui-react/overreact';
import { useGetCouponDetails } from '@bingads-webui/overreact-cc';
import { useCustomerLevelVariables, usePostponeReadVariables } from '@bingads-webui-campaign-react/basic-context-utils';

export const useMultiCouponResolver = (activity) => {
  const [newCoupon, setNewCoupon] = useState(null);

  const customerLevelVariables = useCustomerLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();

  const [{ error }, { read: getCouponDetails }] = useGetCouponDetails(customerLevelVariables, postponeReadConfig);
  const [getCouponDetailsAsync] = usePromisify([getCouponDetails]);

  const [isCouponDetailsLoading, setIsCouponDetailsLoading] = useState(false);

  const resetNewCoupon = useCallback(() => {
    setNewCoupon(null);
  }, []);

  const fetchNewCouponDetails = useCallback((urlCoupon) => {
    if (_.isEmpty(urlCoupon) || isCouponDetailsLoading || error || _.isUndefined(newCoupon)) {
      return;
    }

    const couponParams = (urlCoupon.couponStringType === 'cco') ?
      { cco: urlCoupon.couponString } :
      { ccl: urlCoupon.couponString };

    activity.trace(`Getting details for coupon: ${urlCoupon.couponString}`);
    setIsCouponDetailsLoading(true);
    getCouponDetailsAsync({ variables: couponParams })
      .then((result) => {
        const couponDetails = _.get(result, [0, 'CouponDetails']);
        if (couponDetails) {
          setNewCoupon({
            couponString: urlCoupon.couponString,
            couponStringType: urlCoupon.couponStringType,
            couponDetails: result[0].CouponDetails,
          });
        } else {
          setNewCoupon(undefined);
          activity.trace(`Multi Coupon details not found for coupon: ${urlCoupon.couponString}, type: ${urlCoupon.couponStringType}`);
        }
      })
      .catch(() => {
        activity.trace(`Multi coupon details fetch failed for coupon: ${urlCoupon.couponString}, type: ${urlCoupon.couponStringType}`);
        setNewCoupon(undefined);
      })
      .finally(() => {
        setIsCouponDetailsLoading(false);
      });
  }, [isCouponDetailsLoading, error, newCoupon, activity, getCouponDetailsAsync]);

  return [
    newCoupon,
    fetchNewCouponDetails,
    resetNewCoupon,
  ];
};
